import bus from './bus'
import identity from './identity'

var api = document.getElementById('app').getAttribute('data-api')

// dev (localhost or an ngrok tunnel for mobile testing) talks to the local
// ddev API via the dev-server proxy; only the real prod host uses data-api
if (/(?:^localhost$|^127\.0\.0\.1$|\.ngrok\.io$|\.ngrok-free\.app$)/.test(window.location.hostname)) {

	api = '/api/boxart/'

}

/*
	The same transport every geekgroup frontend uses: a POST of a JSON body to
	`{base}{endpoint}.json`. The session token rides in the body as `auth`
	(NOT an Authorization header), matching tally and the rest of the platform.

	A failed request retries once (a transient blip on the boot session call
	must not surface as a hard failure), then resolves to `{ error: 'network' }`
	and raises a global error so the caller can recover.
*/

export default {

	url: function() {

		return api

	},

	/*
		Absolute URL for an image endpoint, built on the SAME base every api
		request uses (the api.geekgroup.app host in prod, the dev-server proxy
		path in dev/ngrok). Image <img src> URLs must NOT be written relative —
		relative resolves against the SPA origin (boxart.geekgroup.app), which
		serves no API and 404s. e.g. api.image('tile/2026-06-21/0.jpg?v=nc').
	*/
	image: function(path) {

		return api + path

	},

	request: function(url, params) {

		params = params || {}

		// Auto-attach the boxart session token so EVERY authenticated endpoint
		// (stats, signed-in guess, curate/*, today's locked state) is recognised
		// without each caller remembering to pass it. Public endpoints simply
		// ignore the field. A caller may still override by setting params.auth.
		if (typeof params.auth === 'undefined') {

			var token = identity.session()
			if (token) params.auth = token

		}

		var self = this

		return new Promise(function(resolve) {

			self.attempt(api + url + '.json', params, resolve, true)

		})

	},

	// guess autocomplete rides boxart's OWN public endpoint. Returns
	// { suggestions: [{id,name,year}] } scoped to the top-1000 answer pool.
	// `exclude` omits already-guessed ids. Public, so `auth` is ignored.
	suggest: function(text, exclude) {

		return this.request('suggest', { text: text, exclude: exclude || [] })

	},

	attempt: function(endpoint, params, resolve, retry) {

		var self = this

		window.fetch(endpoint, {
			method: 'POST',
			headers: {
				'content-type': 'application/json',
				'x-requested-with': 'xmlhttprequest',
				'ngrok-skip-browser-warning': 'true'
			},
			credentials: 'include',
			body: JSON.stringify(params)
		}).then(function(response) {

			return response.text()

		}).then(function(text) {

			resolve(JSON.parse(text))

		}).catch(function() {

			if (retry) {

				setTimeout(function() {

					self.attempt(endpoint, params, resolve, false)

				}, 600)

				return

			}

			bus.$emit('error', 'We couldn’t reach the server. Check your connection and try again.')

			resolve({ error: 'network' })

		})

	}

}
